import { Report, ReportCategory, ISortable } from './';

export class ReportSubCategory implements ISortable{
    public ReportSubCategoryId:string;

    public Name:string;

    public Description:string;

    public ReportCategoryId:string;

    public ReportCategory:ReportCategory;

    public SortOrder:number;

    public IsDeleted:boolean;

    public Reports:Array<Report>;

    constructor(ReportSubCategoryId:string = "", Name:string = ""){
        this.ReportSubCategoryId = ReportSubCategoryId;
        this.Name = Name;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/report-sub-category.ts